import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/26_blossom/26_blossom"
 * Contains 1 texture(s)
 */
export class Mobile26BlossomAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/26_blossom/26_blossom';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '26_blossom.jpg'
    ] as const;
}
